import {useTranslation} from "@Translation/hooks/useTranslation";
import {
    singleModalTranslationKey
} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";
import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";
import {capitalize} from "@String/capitalize";

interface HowManyTripsContentProps {
    departure: string,
    destination: string,
    transportType: TransportTypesType,
    routeCount: number,
}

function HowManyTripsContent({departure, destination, transportType, routeCount}: HowManyTripsContentProps) {
    const availableTransportationTranslation: Record<TransportTypesType, string> = {
        bus: "buses",
        ferry: "ferries",
        train: "trains",
        privateTransfer: "private transfers",
        plane: "planes",
    }

    const title = useTranslation(
        `${singleModalTranslationKey}.how_many_trips.title`,
        {departure, destination}
    )

    const content = useTranslation(
        `${singleModalTranslationKey}.how_many_trips.description`,
        {
            departure,
            destination,
            availableTransportation: capitalize(availableTransportationTranslation[transportType]),
            routeCount,
        }
    )

    return (
        <TitleAndContent
            title={title}
            content={content}
        />
    )
}

export default HowManyTripsContent